if (!customElements.get('selling-plan-widget')) {
  customElements.define('selling-plan-widget', class SellingPlanWidget extends HTMLElement {
    constructor() {
      super();
      this.quantityInput = this.querySelector("[data-selling-plan-quantity]");
      this.propertiesInput = this.querySelector("[data-selling-plan-properties]");
      this.radios = this.querySelectorAll("input[name='selling_plan']");

      this.radios.forEach(radio => {
        radio.addEventListener('change', () => {
          const planId = radio.value;
          const planQty = radio.dataset.planQuantity || 1;

          // Update quantity input
          this.quantityInput.value = planQty;
          this.propertiesInput.value = planQty * 15 + "PK" ;

          // Update URL without reloading
          const url = new URL(window.location);
          url.searchParams.set('plan', planId);
          window.history.replaceState({}, '', url);
        });
      });
      this.init();
    }

    init() {
      const url = new URL(window.location);
      const planFromUrl = url.searchParams.get('plan');

      let currentPlan;

      if (planFromUrl) {
        // Try to find matching radio by value
        currentPlan = this.querySelector(`input[name='selling_plan'][value='${planFromUrl}']`);
        if (currentPlan) {
          currentPlan.checked = true;
          let quantityInt = currentPlan.dataset.planQuantity || 1;
          this.quantityInput.value = quantityInt;
          this.propertiesInput.value = quantityInt * 15 + "PK" ;
          return;
        }
      }

      // Fallback: select the first checked or first radio
      currentPlan = this.querySelector("input[name='selling_plan']:checked") || this.radios[0];
      if (currentPlan) {
        currentPlan.checked = true;
        let quantityInt = currentPlan.dataset.planQuantity || 1;
        this.quantityInput.value = currentPlan.dataset.planQuantity || 1;
        this.propertiesInput.value = quantityInt * 15 + "PK" ;
      }
    }
  });
}